import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { WHATSAPP_URL } from "@/data/content";
import { WhatsAppIcon } from "@/components/BrandIcons";

// Official WhatsApp green FAB — clean, non-distracting.
export const WhatsAppFAB = () => {
  const { pathname } = useLocation();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 700);
    return () => clearTimeout(t);
  }, []);

  const bottomClass =
    pathname === "/contact" ? "bottom-6" : "bottom-24 md:bottom-6";

  return (
    <motion.a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.5 }}
      animate={ready ? { opacity: 1, scale: 1 } : {}}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className={`group fixed right-5 z-40 grid h-14 w-14 place-items-center rounded-full bg-white shadow-[0_10px_28px_-6px_rgba(37,211,102,0.55)] transition-all duration-300 hover:shadow-[0_14px_32px_-6px_rgba(37,211,102,0.7)] md:right-6 ${bottomClass}`}
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/25" aria-hidden="true" />
      <WhatsAppIcon className="relative h-8 w-8" />
    </motion.a>
  );
};
